import {useQueryParam, StringParam} from 'use-query-params';
import {
  setDynamicLink,
  setCourseTokenValues,
  setCourseInfoValues,
  goToDeviceConfig,
} from './actions';
import {setToken} from 'store/meeting/actions/properties';
import {setMe} from 'store/communication/actions/stateActions';
import {translate} from 'i18n/context/I18nContext';
import {VerifyAndParseToken} from 'utils/communication/Token';
import {logEvent} from 'utils/firebase/analytics';
import {truncateFirebaseAnalyticParameterValue} from 'utils/firebase/utils';
import {
  SET_USER_PERMISSIONS,
  INVALID_TOKEN,
} from 'utils/firebase/analytics.config';
import fetchJsonDataOfCourseInfo from 'utils/communication/DownloadCourseInfo';
import {setLocation} from 'store/world/actions';
import {joinMeeting} from 'store/meeting/actions/meeting';

export const initDynamicLinkHandler = (
  token,
  avatarSelection = false,
  showTrialDemo,
  showLVDemo,
) => {
  return async (dispatch, getState) => {
    // Verify token (reject/return to previous state if invalid)
    const verifiedToken = VerifyAndParseToken(token);
    console.log(
      'verifiedToken from linkActions.web.js:',
      verifiedToken,
      avatarSelection,
    );

    const isTrialDemo =
      String(showTrialDemo || '')
        .trim()
        .toLowerCase() === 'true';
    const isLVDemo =
      String(showLVDemo || '')
        .trim()
        .toLowerCase() === 'true';
    const isDemo = isTrialDemo || isLVDemo;

    // Demo overrides (only applied when demo flags are present)
    const demoWorldToLoad = isLVDemo ? 'liberty_village' : 'benjamin_franklin';
    const demoCourseContentUrl =
      'https://ql-unit-json.s3.us-west-2.amazonaws.com/Demo/demo_unit.json';
    const demoTeacherName = 'Benjamin Franklin';
    const demoDefaultUnitId = 'ba973689-77ce-4f4c-aa61-b9f01bb4c8fa';

    const shouldOverrideToDemo =
      isDemo && verifiedToken.worldToLoad !== 'quikbase';

    const courseTokenValues = {
      worldToLoad: shouldOverrideToDemo
        ? demoWorldToLoad
        : verifiedToken.worldToLoad,
      courseContentUrl: shouldOverrideToDemo
        ? demoCourseContentUrl
        : verifiedToken.courseContentUrl,
      AITeacherToLoad: shouldOverrideToDemo
        ? demoTeacherName
        : verifiedToken.AITeacherToLoad,
      userId:
        verifiedToken.userId !== undefined
          ? verifiedToken.userId
          : 'defaultUserId',
      courseId:
        verifiedToken.courseId !== undefined
          ? verifiedToken.courseId
          : 'defaultCourseId',
      unitId:
        verifiedToken.unitId !== undefined
          ? verifiedToken.unitId
          : shouldOverrideToDemo
            ? demoDefaultUnitId
            : '3125628a-6052-4bb9-907a-86d0ca156d02',
      courseProgress:
        verifiedToken.courseProgress !== undefined
          ? verifiedToken.courseProgress.progress
          : 0,
      collectEmails:
        verifiedToken.collectEmails !== undefined
          ? verifiedToken.collectEmails
          : false,
      isPromotional:
        verifiedToken.isPromotional !== undefined
          ? verifiedToken.isPromotional
          : false,
    };
    (async () => {
      const courseInfoUrl = shouldOverrideToDemo
        ? demoCourseContentUrl
        : verifiedToken.courseContentUrl;
      const {data: resultDataCourseInfo} = await fetchJsonDataOfCourseInfo(
        courseInfoUrl,
      );
      console.log('resultDataCourseInfo', resultDataCourseInfo);

      dispatch(
        setCourseInfoValues(
          resultDataCourseInfo
            ? {
                ...resultDataCourseInfo,
                teacherName: courseTokenValues.AITeacherToLoad, // Keep aligned with courseTokenValues (demo overrides included)
              }
            : resultDataCourseInfo,
        ),
      );
    })();
    console.log(
      'worldToLoad from web initDynamicLinkHandler:',
      courseTokenValues.worldToLoad,
    );
    dispatch(setLocation(courseTokenValues.worldToLoad));

    console.log(
      'courseContentUrl from web initDynamicLinkHandler:',
      courseTokenValues.courseContentUrl,
    );
    console.log(
      'AITeacherToLoad from web initDynamicLinkHandler:',
      courseTokenValues.AITeacherToLoad,
    );
    console.log(
      'userId from web initDynamicLinkHandler:',
      courseTokenValues.userId,
    );
    console.log(
      'courseId from web initDynamicLinkHandler:',
      courseTokenValues.courseId,
    );
    console.log(
      'courseProgress from web initDynamicLinkHandler:',
      courseTokenValues.courseProgress,
    );

    dispatch(setCourseTokenValues(courseTokenValues));

    const {error} = verifiedToken;
    if (error) {
      await dispatch(setDynamicLink(undefined));

      if (token) {
        await logEvent(INVALID_TOKEN, {
          error: error,
        });

        console.error(error);
      }
    } else {
      await dispatch(setDynamicLink(token));
      await dispatch(setToken(token));
      if (!avatarSelection) dispatch(goToDeviceConfig());

      const {peerId, permissions, roomId, integration} = verifiedToken;
      const displayName = translate('linkActionsWeb.userNum', {
        num: peerId.substring(0, 4),
      });
      const displayNameSet = false;
      const device = {};
      await dispatch(
        setMe({peerId, displayName, displayNameSet, device, permissions}),
      );

      const permissionsString = permissions.join(' ');
      await logEvent(SET_USER_PERMISSIONS, {
        meeting_id: roomId,
        integration: integration,
        permissions: truncateFirebaseAnalyticParameterValue(permissionsString),
      });
    }
  };
};
